import React from 'react';
import WorkspaceItemContext from '../../../contexts/workspace/workspace-item-context';
import { useWorkspaceView } from '../hooks/use-view';

export default function DrawingObjectsLayer() {
    const layer = React.useContext(WorkspaceItemContext).drawingObjectsLayer;
    const drawingObjectsView = useWorkspaceView((x) => x.staticData.drawingObjects);

    layer.updateSettings(drawingObjectsView);
    return null;
}
